import { TextProps } from '@uhg-abyss/web/ui/Text';
import React from 'react';

import { TruncatedTextStyled } from './TruncatedText.styled';

interface TruncatedTextProps {
  maxWidth?: string;
  showFullTextOnHover?: boolean;
  children?: string;
  removeTruncatedDataCard?: boolean;
  // Abyss 2.0 requires this component should support asElement prop too
}

export const TruncatedText = ({
  maxWidth,
  showFullTextOnHover = true,
  removeTruncatedDataCard = false,
  children,
  ...props
}: TruncatedTextProps & TextProps) => {
  const hoverTitle = showFullTextOnHover ? children : undefined;

  const Wrapper = showFullTextOnHover ? 'span' : React.Fragment;

  return (
    <Wrapper title={hoverTitle}>
      <TruncatedTextStyled
        css={{
          '&.abyss-text-root': {
            maxWidth,
          },
        }}
        cssProps={{ removeTruncatedDataCard }}
        {...props}
      >
        {children}
      </TruncatedTextStyled>
    </Wrapper>
  );
};
